import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisplayBoardRegistrationComponent } from './display-board-registration.component';

const routes: Routes = [
   {
      path: "",
      component: DisplayBoardRegistrationComponent,
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DisplayBoardRegistrationRoutingModule { }
